import { PORT } from '@repo/sdk'

export const API_URL
  = (import.meta.env as { VITE_API_URL?: string }).VITE_API_URL
    || `http://localhost:${PORT.API}`

export const COOKIE_CONSENT_NAME = 'mentiss:cookie_consent'
